import Modal from '../Modal';
import ModalTitle from '../ModalTitle';

const ContactUpdateNoPermissionModal = ({ isOpen, onClose }) => {
  return (
    <Modal
      className="spo-o-contact-email-exists-warning-modal"
      title={<ModalTitle hasError title="Opgelet!" />}
      isOpen={isOpen}
      onClose={onClose}
      disableConfirm
      disableCancel
    >
      <p>
        Je hebt niet de juiste rechten om deze bewerking uit te voeren. Gelieve contact op te nemen met ons via{' '}
        <a href="mailto:schoolontwikkeling@antwerpen.be">schoolontwikkeling@antwerpen.be</a>.
      </p>
    </Modal>
  );
};

export default ContactUpdateNoPermissionModal;
